import AutocompleteMultiselectionField from '../AutocompleteMultiselectionField'
import AutocompleteUniselectionField from '../AutocompleteUniselectionField/AutocompleteUniselectionField'
import RelationDataField from '../RelationDataField'
import type {
  DataFieldRelationMultiselectionProps,
  DataFieldRelationUniselectionProps
} from './DataFieldRelationAutocomplete.types'

export const DataFieldRelationMultiselection = ({
  commonProps,
  name,
  label,
  objectclassUuid,
  groupedFieldValues,
  displayActions,
  groupPosition,
  dataValue,
  selectAndLinkTargetPath,
  inputRef,
  parentRef,
  onChangeValues,
  interdependentFilteringQuery,
  fieldConcatenation,
  isValid
}: DataFieldRelationMultiselectionProps) => {
  const selectedOptions = Array.isArray(dataValue) ? dataValue : []

  const multiselectionAutocompleteSelectedOptions = selectedOptions.map(
    ({ des, uuid }) => ({ id: uuid, value: des })
  )

  const autoCompleteStatusClass = isValid
    ? ('valid' as const)
    : ('default' as const)

  return (
    <RelationDataField
      name={name}
      label={label}
      objectclassUuid={objectclassUuid}
      groupedFieldValues={groupedFieldValues}
      displayActions={displayActions}
      groupPosition={groupPosition}
      selectedOptions={selectedOptions}
      selectAndLinkTargetPath={selectAndLinkTargetPath}
    >
      <AutocompleteMultiselectionField
        {...commonProps}
        inputRef={inputRef}
        parentRef={parentRef}
        objectclassUuid={objectclassUuid}
        selectedOptions={multiselectionAutocompleteSelectedOptions}
        onChangeValues={onChangeValues}
        interdependentFilteringQuery={interdependentFilteringQuery}
        fieldConcatenation={fieldConcatenation}
        statusClass={autoCompleteStatusClass}
      />
    </RelationDataField>
  )
}

export const DataFieldRelationUniselection = ({
  commonProps,
  name,
  objectclassUuid,
  groupedFieldValues,
  displayActions,
  groupPosition,
  dataValue,
  inputRef,
  onChangeValues,
  uuidCurrentSitemodelObjectclass,
  fieldConcatenation,
  isValid
}: DataFieldRelationUniselectionProps) => {
  const selectedOptions = Array.isArray(dataValue) ? dataValue : []

  const autoCompleteStatusClass = isValid
    ? ('valid' as const)
    : ('default' as const)

  return (
    <RelationDataField
      name={name}
      objectclassUuid={objectclassUuid}
      groupedFieldValues={groupedFieldValues}
      displayActions={displayActions}
      groupPosition={groupPosition}
      selectedOptions={selectedOptions}
    >
      <AutocompleteUniselectionField
        {...commonProps}
        inputRef={inputRef}
        objectclassUuid={objectclassUuid}
        onChangeValues={onChangeValues}
        uuidCurrentSitemodelObjectclass={uuidCurrentSitemodelObjectclass}
        selectedOptions={selectedOptions}
        fieldConcatenation={fieldConcatenation}
        statusClass={autoCompleteStatusClass}
      />
    </RelationDataField>
  )
}
